if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 769px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });

        // Initialiser l'écouteur de changement de variantes
        this.initVariantChangeListener();

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      initVariantChangeListener() {
        console.log('Initialisation de l\'écouteur de changement de variante.');
        // Cible tous les formulaires de produit par leur classe
        const productForms = document.querySelectorAll('form.product-form');

        if (!productForms.length) {
          console.error('Formulaires de produit non trouvés.');
          return;
        }

        // Pour chaque formulaire trouvé, attacher des écouteurs d'événements
        productForms.forEach((productForm) => {
          productForm.querySelectorAll('select[name^="options"], .product-form__input--swatch input, .product-form__input--pill input').forEach((element) => {
            element.addEventListener('change', this.onVariantChange.bind(this));
          });
        });
      }

      onVariantChange(event) {
        const form = event.target.closest('form');

        if (!form) {
          console.error('Formulaire non trouvé.');
          return;
        }

        const selectedOptions = Array.from(form.querySelectorAll('select[name^="options"], input[name^="options"]:checked'))
          .map(el => el.value);

        const variant = this.findVariantByOptions(selectedOptions);

        if (variant) {
          this.updateGallery(variant.id);
        }
      }

      findVariantByOptions(selectedOptions) {
        const variants = window.productVariants || [];
        return variants.find((variant) => {
          return selectedOptions.every((option, index) => {
            return variant.options[index] === option;
          });
        });
      }

      updateGallery(variantId) {
        const galleryImages = this.getCustomGalleryImages(variantId);

        const galleryList = this.elements.viewer.querySelector('.product__media-list');
        if (!galleryList) {
          console.error('Liste de galerie non trouvée.');
          return;
        }

        galleryList.innerHTML = '';

        galleryImages.forEach((imageSrc, index) => {
          const listItem = document.createElement('li');
          listItem.className = 'product__media-item grid__item slider__slide';
          listItem.innerHTML = '<img src="' + imageSrc + '" alt="Product image ' + (index + 1) + '">';
          galleryList.appendChild(listItem);
        });
      }

      getCustomGalleryImages(variantId) {
        const galleryString = window.customVariantGalleries['variant_' + variantId] || '';

        try {
          const galleryImages = galleryString.split(',');
          return galleryImages.map((imageUrl) => imageUrl.trim());
        } catch (error) {
          console.error('Erreur lors du parsing des images de galerie pour la variante:', error);
          return [];
        }
      }


      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}